export default __webpack_public_path__ + "static/sprites-6641a73d5ca774fcd9dcc587b97bb4a7.svg";